document.addEventListener('DOMContentLoaded', function () {
  const mediaWrapper = document.querySelector('.product-gallery-sticky');
  const mediaParent = document.querySelector('.product__media-wrapper');
  const infoWrapper = document.querySelector('.product__info-wrapper');

  if (!mediaWrapper || !mediaParent || !infoWrapper) return;

  const TOP_OFFSET = 7;

  let mediaHeight = 0;
  let wrapperTop = 0;
  let infoBottom = 0;
  let mediaWidth = 0;
  let mediaLeft = 0;

  function resetStyles() {
    mediaWrapper.style.position = '';
    mediaWrapper.style.top = '';
    mediaWrapper.style.left = '';
    mediaWrapper.style.width = '';
    mediaWrapper.style.height = '';
    mediaWrapper.style.bottom = '';
  }

  function calculate() {
    if (window.innerWidth < 990) {
      resetStyles();
      mediaParent.style.position = '';
      mediaParent.style.minHeight = '';
      return;
    }

    /* Reset before measuring */
    mediaWrapper.style.position = 'relative';
    mediaWrapper.style.top = '';
    mediaWrapper.style.left = '';
    mediaWrapper.style.width = '';

    const mediaRect = mediaWrapper.getBoundingClientRect();
    const parentRect = mediaParent.getBoundingClientRect();
    const infoRect = infoWrapper.getBoundingClientRect();

    mediaHeight = mediaRect.height;
    wrapperTop = mediaRect.top + window.scrollY;
    infoBottom = infoRect.bottom + window.scrollY;

    mediaWidth = mediaRect.width;
    mediaLeft = mediaRect.left;

    /*
      Make left column stretch to the height
      of the right product information.
    */
    const requiredHeight = infoBottom - parentRect.top - window.scrollY;

    if (requiredHeight > mediaHeight) {
      mediaParent.style.minHeight = requiredHeight + 'px';
    } else {
      mediaParent.style.minHeight = '';
    }

    update();
  }

  function update() {
    if (window.innerWidth < 990) {
      resetStyles();
      return;
    }

    const scrollTop = window.scrollY;

    const stickyStart = wrapperTop - TOP_OFFSET;

    /*
      Maximum position where gallery can stay.
      Gallery bottom must not go beyond
      the bottom of the product information.
    */
    const maxTop = infoBottom - mediaHeight;

    if (scrollTop < stickyStart) {

      /* NORMAL */
      mediaWrapper.style.position = 'relative';
      mediaWrapper.style.top = '0px';
      mediaWrapper.style.left = '0px';
      mediaWrapper.style.width = '100%';

    } else if (scrollTop < maxTop - TOP_OFFSET) {

      /* FIXED / FROZEN */
      mediaWrapper.style.position = 'fixed';
      mediaWrapper.style.top = TOP_OFFSET + 'px';
      mediaWrapper.style.left = mediaLeft + 'px';
      mediaWrapper.style.width = mediaWidth + 'px';
      mediaWrapper.style.zIndex = '10';

    } else {

      /* RIGHT CONTENT END REACHED */
      mediaWrapper.style.position = 'absolute';
      mediaWrapper.style.top =
        (maxTop - wrapperTop) + 'px';
      mediaWrapper.style.left = '0px';
      mediaWrapper.style.width = '100%';
      mediaWrapper.style.zIndex = '1';

    }
  }

  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });

      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, {
    passive: true
  });

  window.addEventListener('resize', function () {
    calculate();
  });

  /*
    Recalculate if product content changes,
    for example accordions, variants, apps, etc.
  */
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(function () {
      calculate();
    });

    resizeObserver.observe(mediaWrapper);
    resizeObserver.observe(infoWrapper);
  }

  /*
    Images may change gallery height after page load.
  */
  window.addEventListener('load', function () {
    calculate();
  });

  calculate();
});